'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));

var ImportChoiceTypeEnum;
(function (ImportChoiceTypeEnum) {
    ImportChoiceTypeEnum["Update"] = "Update";
    ImportChoiceTypeEnum["Create"] = "Create";
    ImportChoiceTypeEnum["Ignore"] = "Ignore";
})(ImportChoiceTypeEnum || (ImportChoiceTypeEnum = {}));
var ImportChoicePropertyTypeEnum;
(function (ImportChoicePropertyTypeEnum) {
    ImportChoicePropertyTypeEnum["Keep"] = "Keep";
    ImportChoicePropertyTypeEnum["Custom"] = "Custom";
    ImportChoicePropertyTypeEnum["Import"] = "Import";
})(ImportChoicePropertyTypeEnum || (ImportChoicePropertyTypeEnum = {}));

function Diff() {}
Diff.prototype = {
  diff: function diff(oldString, newString) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = options.callback;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    this.options = options;
    var self = this;

    function done(value) {
      if (callback) {
        setTimeout(function () {
          callback(undefined, value);
        }, 0);
        return true;
      } else {
        return value;
      }
    } // Allow subclasses to massage the input prior to running


    oldString = this.castInput(oldString);
    newString = this.castInput(newString);
    oldString = this.removeEmpty(this.tokenize(oldString));
    newString = this.removeEmpty(this.tokenize(newString));
    var newLen = newString.length,
        oldLen = oldString.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [{
      newPos: -1,
      components: []
    }]; // Seed editLength = 0, i.e. the content starts with the same values

    var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);

    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
      // Identity per the equality and tokenizer
      return done([{
        value: this.join(newString),
        count: newString.length
      }]);
    } // Main worker method. checks all permutations of a given edit length for acceptance.


    function execEditLength() {
      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
        var basePath = void 0;

        var addPath = bestPath[diagonalPath - 1],
            removePath = bestPath[diagonalPath + 1],
            _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;

        if (addPath) {
          // No one else is going to attempt to use this value, clear it
          bestPath[diagonalPath - 1] = undefined;
        }

        var canAdd = addPath && addPath.newPos + 1 < newLen,
            canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;

        if (!canAdd && !canRemove) {
          // If this path is a terminal then prune
          bestPath[diagonalPath] = undefined;
          continue;
        } // Select the diagonal that we want to branch from. We select the prior
        // path whose position in the new string is the farthest from the origin
        // and does not pass the bounds of the diff graph


        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
          basePath = clonePath(removePath);
          self.pushComponent(basePath.components, undefined, true);
        } else {
          basePath = addPath; // No need to clone, we've pulled it from the list

          basePath.newPos++;
          self.pushComponent(basePath.components, true, undefined);
        }

        _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath); // If we have hit the end of both strings, then we are done

        if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) {
          return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
        } else {
          // Otherwise track this path as a potential candidate and continue.
          bestPath[diagonalPath] = basePath;
        }
      }

      editLength++;
    } // Performs the length of edit iteration. Is a bit fugly as this has to support the
    // sync and async mode which is never fun. Loops over execEditLength until a value
    // is produced.


    if (callback) {
      (function exec() {
        setTimeout(function () {
          // This should not happen, but we want to be safe.

          /* istanbul ignore next */
          if (editLength > maxEditLength) {
            return callback();
          }

          if (!execEditLength()) {
            exec();
          }
        }, 0);
      })();
    } else {
      while (editLength <= maxEditLength) {
        var ret = execEditLength();

        if (ret) {
          return ret;
        }
      }
    }
  },
  pushComponent: function pushComponent(components, added, removed) {
    var last = components[components.length - 1];

    if (last && last.added === added && last.removed === removed) {
      // We need to clone here as the component clone operation is just
      // as shallow array clone
      components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed
      };
    } else {
      components.push({
        count: 1,
        added: added,
        removed: removed
      });
    }
  },
  extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
    var newLen = newString.length,
        oldLen = oldString.length,
        newPos = basePath.newPos,
        oldPos = newPos - diagonalPath,
        commonCount = 0;

    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])) {
      newPos++;
      oldPos++;
      commonCount++;
    }

    if (commonCount) {
      basePath.components.push({
        count: commonCount
      });
    }

    basePath.newPos = newPos;
    return oldPos;
  },
  equals: function equals(left, right) {
    if (this.options.comparator) {
      return this.options.comparator(left, right);
    } else {
      return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
    }
  },
  removeEmpty: function removeEmpty(array) {
    var ret = [];

    for (var i = 0; i < array.length; i++) {
      if (array[i]) {
        ret.push(array[i]);
      }
    }

    return ret;
  },
  castInput: function castInput(value) {
    return value;
  },
  tokenize: function tokenize(value) {
    return value.split('');
  },
  join: function join(chars) {
    return chars.join('');
  }
};

function buildValues(diff, components, newString, oldString, useLongestToken) {
  var componentPos = 0,
      componentLen = components.length,
      newPos = 0,
      oldPos = 0;

  for (; componentPos < componentLen; componentPos++) {
    var component = components[componentPos];

    if (!component.removed) {
      if (!component.added && useLongestToken) {
        var value = newString.slice(newPos, newPos + component.count);
        value = value.map(function (value, i) {
          var oldValue = oldString[oldPos + i];
          return oldValue.length > value.length ? oldValue : value;
        });
        component.value = diff.join(value);
      } else {
        component.value = diff.join(newString.slice(newPos, newPos + component.count));
      }

      newPos += component.count; // Common case

      if (!component.added) {
        oldPos += component.count;
      }
    } else {
      component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
      oldPos += component.count; // Reverse add and remove so removes are output first to match common convention
      // The diffing algorithm is tied to add then remove output and this is the simplest
      // route to get the desired output with minimal overhead.

      if (componentPos && components[componentPos - 1].added) {
        var tmp = components[componentPos - 1];
        components[componentPos - 1] = components[componentPos];
        components[componentPos] = tmp;
      }
    }
  } // Special case handle for when one terminal is ignored (i.e. whitespace).
  // For this case we merge the terminal into the prior string and drop the change.
  // This is only available for string mode.


  var lastComponent = components[componentLen - 1];

  if (componentLen > 1 && typeof lastComponent.value === 'string' && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
    components[componentLen - 2].value += lastComponent.value;
    components.pop();
  }

  return components;
}

function clonePath(path) {
  return {
    newPos: path.newPos,
    components: path.components.slice(0)
  };
}

function generateOptions(options, defaults) {
  if (typeof options === 'function') {
    defaults.callback = options;
  } else if (options) {
    for (var name in options) {
      /* istanbul ignore else */
      if (options.hasOwnProperty(name)) {
        defaults[name] = options[name];
      }
    }
  }

  return defaults;
}

//
// Ranges and exceptions:
// Latin-1 Supplement, 0080–00FF
//  - U+00D7  × Multiplication sign
//  - U+00F7  ÷ Division sign
// Latin Extended-A, 0100–017F
// Latin Extended-B, 0180–024F
// IPA Extensions, 0250–02AF
// Spacing Modifier Letters, 02B0–02FF
//  - U+02C7  ˇ &#711;  Caron
//  - U+02D8  ˘ &#728;  Breve
//  - U+02D9  ˙ &#729;  Dot Above
//  - U+02DA  ˚ &#730;  Ring Above
//  - U+02DB  ˛ &#731;  Ogonek
//  - U+02DC  ˜ &#732;  Small Tilde
//  - U+02DD  ˝ &#733;  Double Acute Accent
// Latin Extended Additional, 1E00–1EFF

var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
var reWhitespace = /\S/;
var wordDiff = new Diff();

wordDiff.equals = function (left, right) {
  if (this.options.ignoreCase) {
    left = left.toLowerCase();
    right = right.toLowerCase();
  }

  return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
};

wordDiff.tokenize = function (value) {
  var tokens = value.split(/(\s+|[()[\]{}'"]|\b)/); // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.

  for (var i = 0; i < tokens.length - 1; i++) {
    // If we have an empty string in the next field and we have only word chars before and after, merge
    if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
      tokens[i] += tokens[i + 2];
      tokens.splice(i + 1, 2);
      i--;
    }
  }

  return tokens;
};

function diffWords(oldStr, newStr, options) {
  options = generateOptions(options, {
    ignoreWhitespace: true
  });
  return wordDiff.diff(oldStr, newStr, options);
}

var lineDiff = new Diff();

lineDiff.tokenize = function (value) {
  var retLines = [],
      linesAndNewlines = value.split(/(\n|\r\n)/); // Ignore the final empty token that occurs if the string ends with a new line

  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
    linesAndNewlines.pop();
  } // Merge the content and line separators into single tokens


  for (var i = 0; i < linesAndNewlines.length; i++) {
    var line = linesAndNewlines[i];

    if (i % 2 && !this.options.newlineIsToken) {
      retLines[retLines.length - 1] += line;
    } else {
      if (this.options.ignoreWhitespace) {
        line = line.trim();
      }

      retLines.push(line);
    }
  }

  return retLines;
};
function diffTrimmedLines(oldStr, newStr, callback) {
  var options = generateOptions(callback, {
    ignoreWhitespace: true
  });
  return lineDiff.diff(oldStr, newStr, options);
}

var sentenceDiff = new Diff();

sentenceDiff.tokenize = function (value) {
  return value.split(/(\S.+?[.!?])(?=\s+|$)/);
};

function diffSentences(oldStr, newStr, callback) {
  return sentenceDiff.diff(oldStr, newStr, callback);
}

var cssDiff = new Diff();

cssDiff.tokenize = function (value) {
  return value.split(/([{}:;,]|\s+)/);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var objectPrototypeToString = Object.prototype.toString;
var jsonDiff = new Diff(); // Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:

jsonDiff.useLongestToken = true;
jsonDiff.tokenize = lineDiff.tokenize;

jsonDiff.castInput = function (value) {
  var _this$options = this.options,
      undefinedReplacement = _this$options.undefinedReplacement,
      _this$options$stringi = _this$options.stringifyReplacer,
      stringifyReplacer = _this$options$stringi === void 0 ? function (k, v) {
    return typeof v === 'undefined' ? undefinedReplacement : v;
  } : _this$options$stringi;
  return typeof value === 'string' ? value : JSON.stringify(canonicalize(value, null, null, stringifyReplacer), stringifyReplacer, '  ');
};

jsonDiff.equals = function (left, right) {
  return Diff.prototype.equals.call(jsonDiff, left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'));
};

function diffJson(oldObj, newObj, options) {
  return jsonDiff.diff(oldObj, newObj, options);
} // This function handles the presence of circular references by bailing out when encountering an
// object that is already on the "stack" of items being processed. Accepts an optional replacer

function canonicalize(obj, stack, replacementStack, replacer, key) {
  stack = stack || [];
  replacementStack = replacementStack || [];

  if (replacer) {
    obj = replacer(key, obj);
  }

  var i;

  for (i = 0; i < stack.length; i += 1) {
    if (stack[i] === obj) {
      return replacementStack[i];
    }
  }

  var canonicalizedObj;

  if ('[object Array]' === objectPrototypeToString.call(obj)) {
    stack.push(obj);
    canonicalizedObj = new Array(obj.length);
    replacementStack.push(canonicalizedObj);

    for (i = 0; i < obj.length; i += 1) {
      canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack, replacer, key);
    }

    stack.pop();
    replacementStack.pop();
    return canonicalizedObj;
  }

  if (obj && obj.toJSON) {
    obj = obj.toJSON();
  }

  if (_typeof(obj) === 'object' && obj !== null) {
    stack.push(obj);
    canonicalizedObj = {};
    replacementStack.push(canonicalizedObj);

    var sortedKeys = [],
        _key;

    for (_key in obj) {
      /* istanbul ignore else */
      if (obj.hasOwnProperty(_key)) {
        sortedKeys.push(_key);
      }
    }

    sortedKeys.sort();

    for (i = 0; i < sortedKeys.length; i += 1) {
      _key = sortedKeys[i];
      canonicalizedObj[_key] = canonicalize(obj[_key], stack, replacementStack, replacer, _key);
    }

    stack.pop();
    replacementStack.pop();
  } else {
    canonicalizedObj = obj;
  }

  return canonicalizedObj;
}

var arrayDiff = new Diff();

arrayDiff.tokenize = function (value) {
  return value.slice();
};

arrayDiff.join = arrayDiff.removeEmpty = function (value) {
  return value;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var scrollSync = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=7)}([function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0});var r=0;e.default={props:{proportional:Boolean,vertical:Boolean,horizontal:Boolean,group:String},data:function(){return {topNode:null}},beforeCreate:function(){this.uuid=r.toString(),r+=1;},mounted:function(){for(var t=this,e=this.$parent;e;)this.topNode=e,e=this.topNode.$parent;this.topNode.$on("scroll-sync",function(e){if(e.emitter!==t.uuid&&e.group===t.group){var n=e.scrollTop,r=e.scrollHeight,o=e.clientHeight,i=e.scrollLeft,s=e.scrollWidth,c=e.clientWidth,l=e.barHeight,a=e.barWidth,u=r-o,f=s-c,d=t.proportional,p=t.vertical,h=t.horizontal,v=t.$el.scrollHeight-o,_=t.$el.scrollWidth-c;t.$el.onscroll=null,p&&u>l&&(t.$el.scrollTop=d?v*n/u:n),h&&f>a&&(t.$el.scrollLeft=d?_*i/f:i),window.requestAnimationFrame(function(){t.$el.onscroll=t.handleScroll;});}}),this.$el.onscroll=this.handleScroll;},methods:{handleScroll:function(t){var e=this,n=this;window.requestAnimationFrame(function(){var r=t.target,o=r.scrollTop,i=r.scrollHeight,s=r.clientHeight,c=r.scrollLeft,l=r.scrollWidth,a=r.clientWidth,u=r.offsetHeight,f=r.offsetWidth;e.topNode.$emit("scroll-sync",{scrollTop:o,scrollHeight:i,clientHeight:s,scrollLeft:c,scrollWidth:l,clientWidth:a,barHeight:u-s,barWidth:f-a,emitter:n.uuid,group:n.group});});}}};},function(t,e,n){n.d(e,"a",function(){return r}),n.d(e,"b",function(){return o});var r=function(){var t=this.$createElement;return (this._self._c||t)("div",{staticClass:"scroll-sync-container"},[this._t("default")],2)},o=[];r._withStripped=!0;},function(t,e,n){function r(t,e,n,r,o,i,s,c){var l=typeof(t=t||{}).default;"object"!==l&&"function"!==l||(t=t.default);var a,u="function"==typeof t?t.options:t;if(e&&(u.render=e,u.staticRenderFns=n,u._compiled=!0),r&&(u.functional=!0),i&&(u._scopeId=i),s?(a=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(s);},u._ssrRegister=a):o&&(a=c?function(){o.call(this,this.$root.$options.shadowRoot);}:o),a)if(u.functional){u._injectStyles=a;var f=u.render;u.render=function(t,e){return a.call(e),f(t,e)};}else{var d=u.beforeCreate;u.beforeCreate=d?[].concat(d,a):[a];}return {exports:t,options:u}}n.d(e,"a",function(){return r});},function(t,e,n){function r(t,e,n,r){if(r||"undefined"==typeof __VUE_SSR_CONTEXT__||(r=__VUE_SSR_CONTEXT__),r){r.hasOwnProperty("styles")||(Object.defineProperty(r,"styles",{enumerable:!0,get:function(){return o(r._styles)}}),r._renderStyles=o);var i=r._styles||(r._styles={});e=function(t,e){for(var n=[],r={},o=0;o<e.length;o++){var i=e[o],s=i[0],c={id:t+":"+o,css:i[1],media:i[2],sourceMap:i[3]};r[s]?r[s].parts.push(c):n.push(r[s]={id:s,parts:[c]});}return n}(t,e),n?function(t,e){for(var n=0;n<e.length;n++)for(var r=e[n].parts,o=0;o<r.length;o++){var i=r[o],s=i.media||"default",c=t[s];c?c.ids.indexOf(i.id)<0&&(c.ids.push(i.id),c.css+="\n"+i.css):t[s]={ids:[i.id],css:i.css,media:i.media};}}(i,e):function(t,e){for(var n=0;n<e.length;n++)for(var r=e[n].parts,o=0;o<r.length;o++){var i=r[o];t[i.id]={ids:[i.id],css:i.css,media:i.media};}}(i,e);}}function o(t){var e="";for(var n in t){var r=t[n];e+='<style data-vue-ssr-id="'+r.ids.join(" ")+'"'+(r.media?' media="'+r.media+'"':"")+">"+r.css+"</style>";}return e}n.r(e),n.d(e,"default",function(){return r});},function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var n=function(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var o=(s=r,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(s))))+" */"),i=r.sources.map(function(t){return "/*# sourceURL="+r.sourceRoot+t+" */"});return [n].concat(i).concat([o]).join("\n")}var s;return [n].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(r[i]=!0);}for(o=0;o<t.length;o++){var s=t[o];"number"==typeof s[0]&&r[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),e.push(s));}},e};},function(t,e,n){(t.exports=n(4)(!1)).push([t.i,"\n.scroll-sync-container[data-v-12cf087e] {\n    width:100%;\n    height:100%;\n    overflow:auto;\n    position: relative;\n}\n",""]);},function(t,e,n){var r=n(5);"string"==typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);var o=n(3).default;t.exports.__inject__=function(t){o("aecd5d52",r,!1,t);};},function(t,e,n){n.r(e);var r=n(0),o=n.n(r);for(var i in r)"default"!==i&&function(t){n.d(e,t,function(){return r[t]});}(i);var s=n(1),c=n(2);var l=function(t){var e;(e=n(6)).__inject__&&e.__inject__(t);},a=Object(c.a)(o.a,s.a,s.b,!1,l,"data-v-12cf087e","ed1ef43e");a.options.__file="src/ScrollSync.vue",e.default=a.exports;}])});
});

var ScrollSync = unwrapExports(scrollSync);

var script = {
    name: 'mapping-content',
    components: {
        ScrollSync: ScrollSync
    },
    props: {
        data: Object,
        candidates: {},
        index: Number,
        mapping: Object
    },
    data: function () {
        return {
            showDiff: this.mapping.collection.length < 30,
            scrollSync: true
        };
    },
    watch: {
        candidates: function (candidates) {
            var _this = this;
            var values = candidates.map(function (c) { return c.key; });
            values.push(ImportChoiceTypeEnum.Create, ImportChoiceTypeEnum.Ignore);
            this.mapping.collection.forEach(function (c) {
                if (values.indexOf(c.selectedValue) == -1) {
                    c.selectedValue =
                        _this.mapping.canCreate ? ImportChoiceTypeEnum.Create :
                            _this.mapping.canIgnore ? ImportChoiceTypeEnum.Ignore : null;
                }
            });
        }
    },
    methods: {
        getMappingValue: function (item, mapping) {
            if (item.matching && item.matching.key) {
                var match = mapping.candidates.find(function (_) { return _.key === item.matching.key; });
                return match && match.key;
            }
            return null;
        },
        mapAllItems: function (mapping, value) {
            for (var _i = 0, _a = mapping.collection; _i < _a.length; _i++) {
                var item = _a[_i];
                if (value !== undefined) {
                    item.selectedValue = value;
                }
                else {
                    var match = this.getMappingValue(item, mapping);
                    if (match !== undefined) {
                        item.selectedValue = match;
                    }
                }
            }
        },
        getSelectedCandidate: function (mapping, item) {
            return mapping.candidates.find(function (m) { return m.key === item.selectedValue; });
        },
        getSelectedCandidateValue: function (mapping, item, propName) {
            var selectedCandidate = this.getSelectedCandidate(mapping, item);
            if (selectedCandidate == undefined) {
                return null;
            }
            return selectedCandidate.propertyDetails.find(function (p) { return p.key == propName; }).value;
        },
        isIdentical: function (mapping, item, prop) {
            return prop.value === this.getSelectedCandidateValue(mapping, item, prop.key);
        },
        escapeHtml: function (v) {
            return (v + "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },
        delValue: function (value) {
            if (!this.showDiff) {
                return value;
            }
            return "<del>" + value + "</del>";
        },
        insValue: function (value) {
            if (!this.showDiff) {
                return value;
            }
            return "<ins>" + value + "</ins>";
        },
        // Vu que les input ont pas d'objet vue de mappé, on fait à l'ancienne (ça va qu'il y en a pas beaucoup)
        copyData: function (elementId, mapping, item, prop, side) {
            var input = document.getElementById(elementId);
            var editor = document.getElementById(input.dataset.editor);
            switch (side) {
                case "left":
                    input.value = this.getSelectedCandidateValue(mapping, item, prop.key);
                    break;
                case "right":
                    input.value = prop.value;
                    break;
            }
            editor.innerText = input.value;
        },
        updateData: function ($event) {
            var editor = $event.srcElement;
            var input = document.getElementById(editor.dataset.input);
            input.value = editor.innerText;
        },
        stopPropagation: function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return false;
        },
        computeDiff: function (mapping, item, prop, side) {
            var _this = this;
            var diff;
            var dataDb = this.getSelectedCandidateValue(mapping, item, prop.key);
            var dataImported = prop.value;
            var maxEquals = 100;
            var nullValue = "<em style='opacity: 0.5;'>NULL</span>";
            var falseValue = "<i class='fa fa-ban text-danger'></i>";
            var trueValue = "<i class='fa fa-check text-success'></i>";
            var equals = "<em> &ndash; Contenu identique masqué &ndash; </em>";
            // Petit raccourci pour gagner en performances
            if (dataDb === dataImported) {
                switch (dataDb) {
                    case null:
                        return nullValue;
                    case false:
                        return falseValue;
                    case true:
                        return trueValue;
                }
                if (dataDb.length > maxEquals) {
                    return equals;
                }
                return this.escapeHtml(dataDb);
            }
            switch (side) {
                case "left":
                    switch (dataDb) {
                        case null:
                            return this.delValue(nullValue);
                        case false:
                            return this.delValue(falseValue);
                        case true:
                            return this.delValue(trueValue);
                        case "":
                            return "";
                    }
                    if (dataImported === "" || dataImported === null) {
                        return this.delValue(this.escapeHtml(dataDb));
                    }
                    break;
                case "right":
                    switch (dataImported) {
                        case null:
                            return this.insValue(nullValue);
                        case false:
                            return this.insValue(falseValue);
                        case true:
                            return this.insValue(trueValue);
                        case "":
                            return "";
                    }
                    if (dataDb === "" || dataDb === null) {
                        return this.insValue(this.escapeHtml(dataImported));
                    }
                    break;
            }
            dataDb += "";
            dataImported += "";
            if (!this.showDiff) {
                switch (side) {
                    case "left":
                        return this.escapeHtml(dataDb);
                    case "right":
                        return this.escapeHtml(dataImported);
                }
            }
            // string json
            if (dataDb.match(/^\s*[{\[]/) || dataImported.match(/^\s*[{\[]/)) {
                diff = diffJson(dataDb, dataImported);
            }
            // string multiligne
            else if (dataDb.match(/\n/)) {
                diff = diffTrimmedLines(dataDb, dataImported);
            }
            // string avec des mots
            else if (dataDb.match(/\s/)) {
                diff = diffWords(dataDb, dataImported);
            }
            else {
                diff = diffSentences(dataDb, dataImported);
            }
            var html = "";
            diff.forEach(function (part) {
                var value = _this.escapeHtml(part.value);
                switch (side) {
                    case "left":
                        if (part.removed) {
                            html += _this.delValue(value);
                        }
                        break;
                    case "right":
                        if (part.added) {
                            html += _this.insValue(value);
                        }
                        break;
                }
                if (!part.removed && !part.added) {
                    if (value === "") {
                        value = " ";
                    }
                    html += value;
                }
            });
            return html;
        },
    }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      key: _vm.mapping.name,
      class: "tab-pane " + (_vm.index === 0 ? "active" : ""),
      attrs: {
        role: "tabpanel",
        "aria-labelledby": "tab-" + _vm.mapping.hashCode,
        id: "content-" + _vm.mapping.hashCode
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col mapping-collection" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _vm.mapping.canMap || _vm.mapping.canUpdate
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.mapAllItems(_vm.mapping)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-arrows-h" }),
                        _vm._v(" Tout faire correspondre\n                    ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.mapping.canCreate
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.mapAllItems(_vm.mapping, "Create")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-file-o" }),
                        _vm._v(" Tout créer\n                    ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.mapping.canIgnore
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.mapAllItems(_vm.mapping, "Ignore")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-ban" }),
                        _vm._v(" Tout ignorer\n                    ")
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-control custom-checkbox custom-control-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showDiff,
                          expression: "showDiff"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: { type: "checkbox", id: "showDiff-" + _vm.index },
                      domProps: {
                        checked: Array.isArray(_vm.showDiff)
                          ? _vm._i(_vm.showDiff, null) > -1
                          : _vm.showDiff
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.showDiff,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false;
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v);
                            if ($$el.checked) {
                              $$i < 0 && (_vm.showDiff = $$a.concat([$$v]));
                            } else {
                              $$i > -1 &&
                                (_vm.showDiff = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)));
                            }
                          } else {
                            _vm.showDiff = $$c;
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "showDiff-" + _vm.index }
                      },
                      [_vm._v("Afficher le diff")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-control custom-checkbox custom-control-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.scrollSync,
                          expression: "scrollSync"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: {
                        type: "checkbox",
                        id: "scrollSync-" + _vm.index
                      },
                      domProps: {
                        checked: Array.isArray(_vm.scrollSync)
                          ? _vm._i(_vm.scrollSync, null) > -1
                          : _vm.scrollSync
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.scrollSync,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false;
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v);
                            if ($$el.checked) {
                              $$i < 0 && (_vm.scrollSync = $$a.concat([$$v]));
                            } else {
                              $$i > -1 &&
                                (_vm.scrollSync = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)));
                            }
                          } else {
                            _vm.scrollSync = $$c;
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "scrollSync-" + _vm.index }
                      },
                      [
                        _vm._v(
                          "Synchroniser le\n                            scroll"
                        )
                      ]
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm._l(_vm.mapping.collection, function(item, i) {
              return _c(
                "div",
                {
                  key: item.imported.key,
                  staticClass: "row mapping-item mb-1 pb-1"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12 import-detail",
                      class: {
                        "col-md-12": true,
                        "import-detail": true,
                        "text-danger": item.selectedValue === undefined
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          name: "Map." + _vm.mapping.name + "[" + i + "].Type"
                        },
                        domProps: { value: item.imported.typeName }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "hidden",
                          name:
                            "Map." + _vm.mapping.name + "[" + i + "].Imported"
                        },
                        domProps: { value: item.imported.key }
                      }),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "tbl table-condensed data-table" },
                        [
                          _c("tr", [
                            _c("th", { staticClass: "data-title" }),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "data-db",
                                attrs: { title: "En base de données" }
                              },
                              [
                                _c("div", { staticClass: "form-inline" }, [
                                  _c("div", { staticClass: "input-group" }, [
                                    _vm._m(0, true),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: item.selectedValue,
                                            expression: "item.selectedValue"
                                          }
                                        ],
                                        class: {
                                          "choice form-control form-control-sm": true,
                                          "bg-warning":
                                            item.selectedValue === undefined
                                        },
                                        staticStyle: { "max-width": "25em" },
                                        attrs: {
                                          name:
                                            "Map." +
                                            _vm.mapping.name +
                                            "[" +
                                            i +
                                            "].Choice",
                                          required: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value;
                                                return val
                                              });
                                            _vm.$set(
                                              item,
                                              "selectedValue",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            );
                                          }
                                        }
                                      },
                                      [
                                        _vm.mapping.canCreate
                                          ? _c(
                                              "option",
                                              { attrs: { value: "Create" } },
                                              [_vm._v(" — Créer — ")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mapping.canIgnore
                                          ? _c(
                                              "option",
                                              { attrs: { value: "Ignore" } },
                                              [
                                                _vm._v(
                                                  " — Ignorer\n                                                —\n                                            "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mapping.canMap ||
                                        _vm.mapping.canUpdate
                                          ? _vm._l(_vm.candidates, function(
                                              candidate
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: candidate.key
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        candidate.label +
                                                          (item.matching &&
                                                          candidate.key ===
                                                            item.matching.key
                                                            ? " (" +
                                                              item.matchingReason +
                                                              ")"
                                                            : "")
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            })
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _vm.mapping.canMap ||
                                        _vm.mapping.canUpdate
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-secondary",
                                                attrs: {
                                                  disabled:
                                                    item.matching == null,
                                                  type: "button",
                                                  title: "Faire correspondre"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    item.selectedValue = _vm.getMappingValue(
                                                      item,
                                                      _vm.mapping
                                                    );
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-arrows-h"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mapping.canCreate
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-secondary",
                                                attrs: {
                                                  type: "button",
                                                  title: "Créer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    item.selectedValue =
                                                      "Create";
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-file-o"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.mapping.canIgnore
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-secondary",
                                                attrs: {
                                                  type: "button",
                                                  title: "Ignorer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    item.selectedValue =
                                                      "Ignore";
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-ban"
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("th", { staticClass: "data-result" }),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "data-import",
                                attrs: { title: "A importer" }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-fw fa-file-code-o"
                                }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.imported.label) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          item.selectedValue !== "Ignore"
                            ? _c(
                                "tbody",
                                _vm._l(item.imported.propertyDetails, function(
                                  prop
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: prop.key,
                                      class: _vm.isIdentical(
                                        _vm.mapping,
                                        item,
                                        prop
                                      )
                                        ? "data-identical"
                                        : "data-different"
                                    },
                                    [
                                      _c("th", { staticClass: "data-title" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(prop.label) +
                                            "\n                                "
                                        ),
                                        _c("em", [_vm._v(_vm._s(prop.type))])
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "data-db" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-radio",
                                            attrs: {
                                              title: "Conserver la valeur"
                                            }
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "radio",
                                                checked: "",
                                                name:
                                                  "Map." +
                                                  _vm.mapping.name +
                                                  "[" +
                                                  i +
                                                  "].Update." +
                                                  prop.key,
                                                id:
                                                  "Map." +
                                                  _vm.mapping.name +
                                                  "[" +
                                                  i +
                                                  "].UpdateKeep." +
                                                  prop.key,
                                                value: "Keep"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "custom-control-label",
                                                attrs: {
                                                  for:
                                                    "Map." +
                                                    _vm.mapping.name +
                                                    "[" +
                                                    i +
                                                    "].UpdateKeep." +
                                                    prop.key
                                                }
                                              },
                                              [
                                                _c(
                                                  "scroll-sync",
                                                  {
                                                    attrs: {
                                                      proportional: "",
                                                      vertical: _vm.scrollSync,
                                                      group:
                                                        "group-" +
                                                        _vm.mapping.name +
                                                        "-" +
                                                        i +
                                                        "-" +
                                                        prop.key
                                                    }
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "data-diff",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.computeDiff(
                                                            _vm.mapping,
                                                            item,
                                                            prop,
                                                            "left"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "data-result" }, [
                                        prop.updatable &&
                                        _vm.mapping.canUpdate &&
                                        prop.type === "String"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-radio",
                                                attrs: {
                                                  title:
                                                    "Personaliser la valeur"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "hidden",
                                                    id:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Custom." +
                                                      prop.key,
                                                    name:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Custom." +
                                                      prop.key,
                                                    "data-editor":
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].CustomEditor." +
                                                      prop.key
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Update." +
                                                      prop.key,
                                                    id:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].UpdateCustom." +
                                                      prop.key,
                                                    value: "Custom"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "Map." +
                                                        _vm.mapping.name +
                                                        "[" +
                                                        i +
                                                        "].UpdateCustom." +
                                                        prop.key
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-prepend",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.copyData(
                                                                  "Map." +
                                                                    _vm.mapping
                                                                      .name +
                                                                    "[" +
                                                                    i +
                                                                    "].Custom." +
                                                                    prop.key,
                                                                  _vm.mapping,
                                                                  item,
                                                                  prop,
                                                                  "left"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._m(1, true)]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "scroll-sync",
                                                          {
                                                            attrs: {
                                                              proportional: "",
                                                              vertical:
                                                                _vm.scrollSync,
                                                              group:
                                                                "group-" +
                                                                _vm.mapping
                                                                  .name +
                                                                "-" +
                                                                i +
                                                                "-" +
                                                                prop.key
                                                            }
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "result-editor data-diff",
                                                              attrs: {
                                                                contenteditable:
                                                                  "true",
                                                                id:
                                                                  "Map." +
                                                                  _vm.mapping
                                                                    .name +
                                                                  "[" +
                                                                  i +
                                                                  "].CustomEditor." +
                                                                  prop.key,
                                                                "data-input":
                                                                  "Map." +
                                                                  _vm.mapping
                                                                    .name +
                                                                  "[" +
                                                                  i +
                                                                  "].Custom." +
                                                                  prop.key
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.stopPropagation,
                                                                input:
                                                                  _vm.updateData
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-append",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.copyData(
                                                                  "Map." +
                                                                    _vm.mapping
                                                                      .name +
                                                                    "[" +
                                                                    i +
                                                                    "].Custom." +
                                                                    prop.key,
                                                                  _vm.mapping,
                                                                  item,
                                                                  prop,
                                                                  "right"
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._m(2, true)]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "data-import" }, [
                                        item.selectedValue !== "Create" &&
                                        prop.updatable &&
                                        _vm.mapping.canUpdate
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-radio",
                                                attrs: {
                                                  title:
                                                    "Mettre à jour la valeur"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Update." +
                                                      prop.key,
                                                    id:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].UpdateImport." +
                                                      prop.key,
                                                    value: "Import"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label w-100",
                                                    attrs: {
                                                      for:
                                                        "Map." +
                                                        _vm.mapping.name +
                                                        "[" +
                                                        i +
                                                        "].UpdateImport." +
                                                        prop.key
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "scroll-sync",
                                                      {
                                                        attrs: {
                                                          proportional: "",
                                                          vertical:
                                                            _vm.scrollSync,
                                                          group:
                                                            "group-" +
                                                            _vm.mapping.name +
                                                            "-" +
                                                            i +
                                                            "-" +
                                                            prop.key
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "data-diff",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.computeDiff(
                                                                _vm.mapping,
                                                                item,
                                                                prop,
                                                                "right"
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : item.selectedValue === "Create" &&
                                            prop.updatable &&
                                            _vm.mapping.canCreate
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-radio"
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Update." +
                                                      prop.key,
                                                    id:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].UpdateImport." +
                                                      prop.key,
                                                    value: "Import",
                                                    checked: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label w-100",
                                                    attrs: {
                                                      for:
                                                        "Map." +
                                                        _vm.mapping.name +
                                                        "[" +
                                                        i +
                                                        "].UpdateImport." +
                                                        prop.key
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "scroll-sync",
                                                      {
                                                        attrs: {
                                                          proportional: "",
                                                          vertical:
                                                            _vm.scrollSync,
                                                          group:
                                                            "group-" +
                                                            _vm.mapping.name +
                                                            "-" +
                                                            i +
                                                            "-" +
                                                            prop.key
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "data-diff",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.computeDiff(
                                                                _vm.mapping,
                                                                item,
                                                                prop,
                                                                "right"
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-radio"
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].Update." +
                                                      prop.key,
                                                    id:
                                                      "Map." +
                                                      _vm.mapping.name +
                                                      "[" +
                                                      i +
                                                      "].UpdateImport." +
                                                      prop.key,
                                                    value: "Import",
                                                    disabled: ""
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label w-100",
                                                    attrs: {
                                                      title:
                                                        "Champ non modifiable",
                                                      for:
                                                        "Map." +
                                                        _vm.mapping.name +
                                                        "[" +
                                                        i +
                                                        "].UpdateImport." +
                                                        prop.key
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "scroll-sync",
                                                      {
                                                        attrs: {
                                                          proportional: "",
                                                          vertical:
                                                            _vm.scrollSync,
                                                          group:
                                                            "group-" +
                                                            _vm.mapping.name +
                                                            "-" +
                                                            i +
                                                            "-" +
                                                            prop.key
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "data-diff",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.computeDiff(
                                                                _vm.mapping,
                                                                item,
                                                                prop,
                                                                "right"
                                                              )
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fa fa-fw fa-database" })
      ])
    ])
  },
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-arrow-right" })
    ])
  },
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-arrow-left" })
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-114ca1bd_0", { source: ".data-table .data-result > .custom-control label > .input-group, .data-table .data-result > .custom-control label, .data-table .data-result > .custom-control {\n  position: absolute;\n  margin: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.mapping-item {\n  border-bottom: 1px solid #eee;\n}\n#import-tabs {\n  position: sticky;\n  top: 1rem;\n}\n.data-diff {\n  white-space: pre-wrap;\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n.data-diff ins, .data-diff del {\n  text-decoration: none;\n}\n.data-diff ins {\n  background: rgba(63, 147, 73, 0.25);\n}\n.data-diff del {\n  background: rgba(255, 133, 111, 0.25);\n}\n.data-table {\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n  font-size: 0.875rem;\n}\n.data-table td, .data-table th {\n  padding: 1px 2px;\n  border: 1px solid #eee;\n}\n.data-table td {\n  overflow: auto;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.data-table td input + label {\n  opacity: 0.6;\n}\n.data-table td input:checked + label {\n  opacity: 1;\n}\n.data-table th {\n  background: rgba(0, 0, 0, 0.05);\n}\n.data-table .scroll-sync-container {\n  max-height: 20em;\n  overflow: auto;\n  position: relative;\n}\n.data-table .data-db, .data-table .data-result, .data-table .data-import {\n  padding: 0;\n  width: 30%;\n}\n.data-table .data-db label, .data-table .data-import label {\n  width: 100%;\n}\n.data-table .data-title {\n  line-height: 1.1;\n}\n.data-table .data-title em {\n  float: right;\n  font-size: 0.8em;\n  font-weight: normal;\n  color: #999;\n}\n.data-table .data-result {\n  position: relative;\n  overflow: visible;\n}\n.data-table .data-result > .custom-control label {\n  left: 24px;\n}\n.data-table .data-result > .custom-control label .input-group-text {\n  padding: 0.25em;\n  cursor: pointer;\n}\n.data-table .data-result > .custom-control label .input-group-text i {\n  font-size: 10px;\n}\n.data-table .data-result > .custom-control label > .input-group {\n  margin: -1px;\n  right: -3px;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container {\n  flex: 1;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container .result-editor {\n  padding: 2px 1px;\n  width: 100%;\n  height: 100%;\n  cursor: text;\n  background: transparent;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container .result-editor:focus {\n  outline: 0 solid transparent;\n}\n.data-table .data-different th {\n  background: #ffd2be;\n}\n\n/*# sourceMappingURL=MappingContent.vue.map */", map: {"version":3,"sources":["C:\\Dev\\orezo\\vendor\\helium\\src\\Helium.SettingsImportExport.Mvc\\_wwwsrc\\src\\js\\Components\\MappingContent.vue","MappingContent.vue"],"names":[],"mappings":"AA0eA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;ACzeA;AD4eA;EACA,6BAAA;ACzeA;AD4eA;EACA,gBAAA;EACA,SAAA;ACzeA;AD4eA;EACA,qBAAA;EAEA,iGAAA;AC1eA;AD4eA;EACA,qBAAA;AC1eA;AD6eA;EACA,mCAAA;AC3eA;AD8eA;EACA,qCAAA;AC5eA;ADgfA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AC7eA;AD+eA;EACA,gBAAA;EACA,sBAAA;AC7eA;ADgfA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;AC9eA;ADgfA;EACA,YAAA;AC9eA;ADifA;EACA,UAAA;AC/eA;ADmfA;EACA,+BAAA;ACjfA;ADofA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AClfA;ADqfA;EACA,UAAA;EACA,UAAA;ACnfA;ADufA;EACA,WAAA;ACrfA;ADyfA;EACA,gBAAA;ACvfA;ADyfA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;ACvfA;AD2fA;EACA,kBAAA;EACA,iBAAA;ACzfA;AD8fA;EAEA,UAAA;AC7fA;AD+fA;EACA,eAAA;EACA,eAAA;AC7fA;AD+fA;EACA,eAAA;AC7fA;ADigBA;EAGA,YAAA;EACA,WAAA;ACjgBA;ADmgBA;EACA,OAAA;ACjgBA;ADmgBA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;ACjgBA;ADmgBA;EACA,4BAAA;ACjgBA;AD0gBA;EACA,mBAAA;ACxgBA;;AAEA,6CAA6C","file":"MappingContent.vue","sourcesContent":["<template>\r\n    <div :class=\"'tab-pane ' + (index === 0 ? 'active' : '')\"\r\n         role=\"tabpanel\"\r\n         :key=\"mapping.name\"\r\n         :aria-labelledby=\"'tab-' + mapping.hashCode\"\r\n         :id=\"'content-' + mapping.hashCode\">\r\n        <div class=\"row\">\r\n            <div class=\"col mapping-collection\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <button v-if=\"mapping.canMap || mapping.canUpdate\"\r\n                                class=\"btn btn-sm btn-outline-secondary\" type=\"button\"\r\n                                @click=\"mapAllItems(mapping)\">\r\n                            <i class=\"fa fa-arrows-h\"></i> Tout faire correspondre\r\n                        </button>\r\n\r\n                        <button v-if=\"mapping.canCreate\"\r\n                                class=\"btn btn-sm btn-outline-secondary\" type=\"button\"\r\n                                @click=\"mapAllItems(mapping, 'Create')\">\r\n                            <i class=\"fa fa-file-o\"></i> Tout créer\r\n                        </button>\r\n\r\n                        <button v-if=\"mapping.canIgnore\"\r\n                                class=\"btn btn-sm btn-outline-secondary\" type=\"button\"\r\n                                @click=\"mapAllItems(mapping, 'Ignore')\">\r\n                            <i class=\"fa fa-ban\"></i> Tout ignorer\r\n                        </button>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n                            <input type=\"checkbox\" class=\"custom-control-input\" :id=\"'showDiff-'+index\"\r\n                                   v-model=\"showDiff\">\r\n                            <label class=\"custom-control-label\" :for=\"'showDiff-'+index\">Afficher le diff</label>\r\n                        </div>\r\n                        <div class=\"custom-control custom-checkbox custom-control-inline\">\r\n                            <input type=\"checkbox\" class=\"custom-control-input\" :id=\"'scrollSync-'+index\"\r\n                                   v-model=\"scrollSync\">\r\n                            <label class=\"custom-control-label\" :for=\"'scrollSync-'+index\">Synchroniser le\r\n                                scroll</label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <hr/>\r\n\r\n                <div v-for=\"(item, i) of mapping.collection\" class=\"row mapping-item mb-1 pb-1\"\r\n                     :key=\"item.imported.key\">\r\n                    <div class=\"col-md-12 import-detail\"\r\n                         :class=\"{'col-md-12': true, 'import-detail': true, 'text-danger': item.selectedValue === undefined}\">\r\n                        <input type=\"hidden\" :name=\"'Map.'+mapping.name+'['+i+'].Type'\" :value=\"item.imported.typeName\"/>\r\n                        <input type=\"hidden\" :name=\"'Map.'+mapping.name+'['+i+'].Imported'\" :value=\"item.imported.key\"/>\r\n\r\n                        <table class=\"tbl table-condensed data-table\">\r\n                            <tr>\r\n                                <th class=\"data-title\"></th>\r\n                                <th class=\"data-db\" title=\"En base de données\">\r\n                                    <div class=\"form-inline\">\r\n                                        <div class=\"input-group\">\r\n                                            <div class=\"input-group-prepend\">\r\n                                                <div class=\"input-group-text\"><i class=\"fa fa-fw fa-database\"></i></div>\r\n                                            </div>\r\n                                            <select :name=\"'Map.'+mapping.name+'['+i+'].Choice'\"\r\n                                                    required\r\n                                                    :class=\"{'choice form-control form-control-sm': true, 'bg-warning': item.selectedValue === undefined}\"\r\n                                                    style=\"max-width: 25em;\"\r\n                                                    v-model=\"item.selectedValue\">\r\n                                                <option v-if=\"mapping.canCreate\" value=\"Create\"> &mdash; Créer &mdash; </option>\r\n                                                <option v-if=\"mapping.canIgnore\" value=\"Ignore\"> &mdash; Ignorer\r\n                                                    &mdash;\r\n                                                </option>\r\n\r\n                                                <template v-if=\"mapping.canMap || mapping.canUpdate\">\r\n                                                    <option v-for=\"candidate of candidates\" :value=\"candidate.key\">\r\n                                                        {{candidate.label + (item.matching && candidate.key ===\r\n                                                        item.matching.key ?\r\n                                                        ` (${item.matchingReason})` : '')}}\r\n                                                    </option>\r\n                                                </template>\r\n                                            </select>\r\n                                            <div class=\"input-group-append\">\r\n                                                <button v-if=\"mapping.canMap || mapping.canUpdate\"\r\n                                                        :disabled=\"item.matching == null\"\r\n                                                        class=\"btn btn-sm btn-outline-secondary\" type=\"button\"\r\n                                                        @click=\"item.selectedValue = getMappingValue(item, mapping)\"\r\n                                                        title=\"Faire correspondre\">\r\n                                                    <i class=\"fa fa-arrows-h\"></i>\r\n                                                </button>\r\n\r\n                                                <button v-if=\"mapping.canCreate\"\r\n                                                        class=\"btn btn-sm btn-outline-secondary\"\r\n                                                        type=\"button\" @click=\"item.selectedValue = 'Create'\"\r\n                                                        title=\"Créer\">\r\n                                                    <i class=\"fa fa-file-o\"></i>\r\n                                                </button>\r\n\r\n                                                <button v-if=\"mapping.canIgnore\"\r\n                                                        class=\"btn btn-sm btn-outline-secondary\"\r\n                                                        type=\"button\" @click=\"item.selectedValue = 'Ignore'\"\r\n                                                        title=\"Ignorer\">\r\n                                                    <i class=\"fa fa-ban\"></i>\r\n                                                </button>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </th>\r\n                                <th class=\"data-result\"></th>\r\n                                <th class=\"data-import\" title=\"A importer\">\r\n                                    <i class=\"fa fa-fw fa-file-code-o\"></i>\r\n                                    {{item.imported.label}}\r\n                                </th>\r\n                            </tr>\r\n\r\n                            <tbody v-if=\"item.selectedValue !== 'Ignore'\">\r\n                            <tr v-for=\"prop in item.imported.propertyDetails\" :key=\"prop.key\"\r\n                                :class=\"isIdentical(mapping, item, prop) ? 'data-identical' : 'data-different'\">\r\n                                <th class=\"data-title\">\r\n                                    {{prop.label}}\r\n                                    <em>{{prop.type}}</em>\r\n                                </th>\r\n                                <td class=\"data-db\">\r\n                                    <div \r\n                                         class=\"custom-control custom-radio\" title=\"Conserver la valeur\">\r\n                                        <input type=\"radio\" class=\"custom-control-input\"\r\n                                               checked\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Update.'+prop.key\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].UpdateKeep.'+prop.key\"\r\n                                               value=\"Keep\"/>\r\n                                        <label class=\"custom-control-label\"\r\n                                               :for=\"'Map.'+mapping.name+'['+i+'].UpdateKeep.'+prop.key\">\r\n                                            <scroll-sync proportional :vertical=\"scrollSync\"\r\n                                                         :group=\"`group-${mapping.name}-${i}-${prop.key}`\">\r\n                                                <div class=\"data-diff\" v-html=\"computeDiff(mapping, item, prop, 'left')\"></div>\r\n                                            </scroll-sync>\r\n                                        </label>\r\n                                    </div>\r\n                                </td>\r\n                                \r\n                                <td class=\"data-result\">\r\n                                    <div v-if=\"prop.updatable && mapping.canUpdate && prop.type === 'String'\"\r\n                                         class=\"custom-control custom-radio\" title=\"Personaliser la valeur\">\r\n                                        <input type=\"hidden\" class=\"custom-control-input\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].Custom.'+prop.key\"\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Custom.'+prop.key\"\r\n                                               :data-editor=\"'Map.'+mapping.name+'['+i+'].CustomEditor.'+prop.key\"\r\n                                        />\r\n                                        \r\n                                        <input type=\"radio\" class=\"custom-control-input\"\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Update.'+prop.key\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].UpdateCustom.'+prop.key\"\r\n                                               value=\"Custom\"/>\r\n                                        \r\n                                        <label class=\"custom-control-label\" \r\n                                               :for=\"'Map.'+mapping.name+'['+i+'].UpdateCustom.'+prop.key\">\r\n                                            <div class=\"input-group\">\r\n                                                <div class=\"input-group-prepend\" \r\n                                                     @click=\"copyData('Map.'+mapping.name+'['+i+'].Custom.'+prop.key, mapping, item, prop, 'left')\">\r\n                                                    <span class=\"input-group-text\"><i class=\"fa fa-arrow-right\"></i></span>\r\n                                                </div>\r\n                                                \r\n                                                <scroll-sync proportional :vertical=\"scrollSync\"\r\n                                                             :group=\"`group-${mapping.name}-${i}-${prop.key}`\">\r\n                                                    <div contenteditable=\"true\" class=\"result-editor data-diff\" \r\n                                                         :id=\"'Map.'+mapping.name+'['+i+'].CustomEditor.'+prop.key\"\r\n                                                         :data-input=\"'Map.'+mapping.name+'['+i+'].Custom.'+prop.key\"\r\n                                                         @click=\"stopPropagation\"\r\n                                                         @input=\"updateData\"></div>\r\n                                                </scroll-sync>\r\n                                                \r\n                                                <div class=\"input-group-append\" \r\n                                                     @click=\"copyData('Map.'+mapping.name+'['+i+'].Custom.'+prop.key, mapping, item, prop, 'right')\">\r\n                                                    <span class=\"input-group-text\"><i class=\"fa fa-arrow-left\"></i></span>\r\n                                                </div>\r\n                                            </div>\r\n                                        </label>\r\n                                    </div>\r\n                                </td>\r\n                                \r\n                                <td class=\"data-import\">\r\n                                    <!-- Cas de la modif d'objet -->\r\n                                    <div v-if=\"item.selectedValue !== 'Create' && prop.updatable && mapping.canUpdate\"\r\n                                         class=\"custom-control custom-radio\" title=\"Mettre à jour la valeur\">\r\n                                        <input type=\"radio\" class=\"custom-control-input\"\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Update.'+prop.key\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\"\r\n                                               value=\"Import\"/>\r\n                                        <label class=\"custom-control-label w-100\"\r\n                                               :for=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\">\r\n                                            <scroll-sync proportional :vertical=\"scrollSync\"\r\n                                                         :group=\"`group-${mapping.name}-${i}-${prop.key}`\">\r\n                                                <div class=\"data-diff\"\r\n                                                     v-html=\"computeDiff(mapping, item, prop, 'right')\"></div>\r\n                                            </scroll-sync>\r\n                                        </label>\r\n                                    </div>\r\n\r\n                                    <!-- Cas de la création d'objet -->\r\n                                    <div\r\n                                        v-else-if=\"item.selectedValue === 'Create' && prop.updatable && mapping.canCreate\"\r\n                                        class=\"custom-control custom-radio\">\r\n                                        <input type=\"radio\" class=\"custom-control-input\"\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Update.'+prop.key\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\"\r\n                                               value=\"Import\"\r\n                                               checked/>\r\n                                        <label class=\"custom-control-label w-100\"\r\n                                               :for=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\">\r\n                                            <scroll-sync proportional :vertical=\"scrollSync\"\r\n                                                         :group=\"`group-${mapping.name}-${i}-${prop.key}`\">\r\n                                                <div class=\"data-diff\"\r\n                                                     v-html=\"computeDiff(mapping, item, prop, 'right')\"></div>\r\n                                            </scroll-sync>\r\n                                        </label>\r\n                                    </div>\r\n\r\n                                    <!-- Cas ou la modif est impossible -->\r\n                                    <div v-else class=\"custom-control custom-radio\">\r\n                                        <input type=\"radio\" class=\"custom-control-input\"\r\n                                               :name=\"'Map.'+mapping.name+'['+i+'].Update.'+prop.key\"\r\n                                               :id=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\"\r\n                                               value=\"Import\"\r\n                                               disabled />\r\n                                        <label class=\"custom-control-label w-100\" title=\"Champ non modifiable\"\r\n                                               :for=\"'Map.'+mapping.name+'['+i+'].UpdateImport.'+prop.key\">\r\n                                            <scroll-sync proportional :vertical=\"scrollSync\"\r\n                                                         :group=\"`group-${mapping.name}-${i}-${prop.key}`\">\r\n                                                <div class=\"data-diff\"\r\n                                                     v-html=\"computeDiff(mapping, item, prop, 'right')\"></div>\r\n                                            </scroll-sync>\r\n                                        </label>\r\n                                    </div>\r\n                                </td>\r\n                            </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script lang=\"ts\">\r\n    import * as Diff from \"diff\";\r\n    import ScrollSync from \"vue-scroll-sync\";\r\n    import {ImportMappingCollection} from \"../Models/ImportMappingCollection\";\r\n    import {ImportableObjectPropertyDetail} from \"../Models/ImportableObjectPropertyDetail\";\r\n    import {ImportMappingItem} from \"../Models/ImportMappingItem\";\r\n    import {ImportPrepareViewModel} from \"../Models/ImportPrepareViewModel\";\r\n    import {ImportContainerBase} from \"../Models/ImportContainerBase\";\r\n    import {ImportChoiceTypeEnum} from \"../Models/ImportableChoiceType\";\r\n\r\n    export default {\r\n        name: 'mapping-content',\r\n        components: {\r\n            ScrollSync\r\n        },\r\n        props: {\r\n            data: Object as () => ImportPrepareViewModel,\r\n            candidates: {},\r\n            index: Number,\r\n            mapping: Object as () => ImportMappingCollection\r\n        },\r\n        data() {\r\n            return {\r\n                showDiff: this.mapping.collection.length < 30,\r\n                scrollSync: true\r\n            }\r\n        },\r\n        watch: {\r\n            candidates(candidates) {\r\n                let values = candidates.map(c => c.key);\r\n                values.push(ImportChoiceTypeEnum.Create, ImportChoiceTypeEnum.Ignore);\r\n\r\n                this.mapping.collection.forEach(c => {\r\n                    if (values.indexOf(c.selectedValue) == -1) {\r\n                        c.selectedValue =\r\n                            this.mapping.canCreate ? ImportChoiceTypeEnum.Create :\r\n                                this.mapping.canIgnore ? ImportChoiceTypeEnum.Ignore : null;\r\n                    }\r\n                });\r\n            }\r\n        },\r\n        methods: {\r\n            getMappingValue(item: ImportMappingItem, mapping: ImportMappingCollection): string {\r\n                if (item.matching && item.matching.key) {\r\n                    const match = mapping.candidates.find(_ => _.key === item.matching.key);\r\n\r\n                    return match && match.key;\r\n                }\r\n\r\n                return null;\r\n            },\r\n            mapAllItems(mapping: ImportMappingCollection, value?: any) {\r\n                for (let item of mapping.collection) {\r\n                    if (value !== undefined) {\r\n                        item.selectedValue = value;\r\n                    } else {\r\n                        let match = this.getMappingValue(item, mapping);\r\n\r\n                        if (match !== undefined) {\r\n                            item.selectedValue = match;\r\n                        }\r\n                    }\r\n                }\r\n            },\r\n            getSelectedCandidate(mapping: ImportMappingCollection, item: ImportMappingItem): ImportContainerBase {\r\n                return mapping.candidates.find(m => m.key === item.selectedValue);\r\n            },\r\n            getSelectedCandidateValue(mapping: ImportMappingCollection, item: ImportMappingItem, propName: string): string | null {\r\n                const selectedCandidate = this.getSelectedCandidate(mapping, item);\r\n\r\n                if (selectedCandidate == undefined) {\r\n                    return null;\r\n                }\r\n\r\n                return selectedCandidate.propertyDetails.find(p => p.key == propName).value;\r\n            },\r\n            isIdentical(mapping: ImportMappingCollection, item: ImportMappingItem, prop: ImportableObjectPropertyDetail) {\r\n                return prop.value === this.getSelectedCandidateValue(mapping, item, prop.key);\r\n            },\r\n            escapeHtml(v: string | null | boolean) {\r\n                return (v + \"\").replace(/</g, \"&lt;\").replace(/>/g, \"&gt;\");\r\n            },\r\n            delValue(value: string) {\r\n                if (!this.showDiff) {\r\n                    return value;\r\n                }\r\n                return `<del>${value}</del>`;\r\n            },\r\n            insValue(value: string) {\r\n                if (!this.showDiff) {\r\n                    return value;\r\n                }\r\n                return `<ins>${value}</ins>`;\r\n            },\r\n            // Vu que les input ont pas d'objet vue de mappé, on fait à l'ancienne (ça va qu'il y en a pas beaucoup)\r\n            copyData(elementId: string, mapping: ImportMappingCollection, item: ImportMappingItem, prop: ImportableObjectPropertyDetail, side: string) {\r\n                let input = document.getElementById(elementId) as HTMLInputElement;\r\n                let editor = document.getElementById(input.dataset.editor) as HTMLDivElement;\r\n                \r\n                switch (side) {\r\n                    case \"left\":\r\n                        input.value = this.getSelectedCandidateValue(mapping, item, prop.key);\r\n                        break;\r\n                    case \"right\":\r\n                        input.value = prop.value;\r\n                        break;\r\n                }\r\n                \r\n                editor.innerText = input.value;\r\n            },\r\n            updateData($event: Event) {\r\n                let editor = $event.srcElement as HTMLDivElement;\r\n                let input = document.getElementById(editor.dataset.input) as HTMLInputElement;\r\n\r\n                input.value = editor.innerText;\r\n            },\r\n            stopPropagation($event) {\r\n                $event.stopPropagation();\r\n                $event.preventDefault();\r\n                return false;\r\n            },\r\n            computeDiff(mapping: ImportMappingCollection, item: ImportMappingItem, prop: ImportableObjectPropertyDetail, side: string) {\r\n                let diff;\r\n                let dataDb = this.getSelectedCandidateValue(mapping, item, prop.key);\r\n                let dataImported = prop.value;\r\n\r\n                const maxEquals = 100;\r\n                const nullValue = \"<em style='opacity: 0.5;'>NULL</span>\";\r\n                const falseValue = \"<i class='fa fa-ban text-danger'></i>\";\r\n                const trueValue = \"<i class='fa fa-check text-success'></i>\";\r\n                const equals = \"<em> &ndash; Contenu identique masqué &ndash; </em>\";\r\n\r\n                // Petit raccourci pour gagner en performances\r\n                if (dataDb === dataImported) {\r\n                    switch (dataDb) {\r\n                        case null:\r\n                            return nullValue;\r\n                        case false:\r\n                            return falseValue;\r\n                        case true:\r\n                            return trueValue;\r\n                    }\r\n\r\n                    if (dataDb.length > maxEquals) {\r\n                        return equals;\r\n                    }\r\n\r\n                    return this.escapeHtml(dataDb);\r\n                }\r\n\r\n                switch (side) {\r\n                    case \"left\":\r\n                        switch (dataDb) {\r\n                            case null:\r\n                                return this.delValue(nullValue);\r\n                            case false:\r\n                                return this.delValue(falseValue);\r\n                            case true:\r\n                                return this.delValue(trueValue);\r\n                            case \"\":\r\n                                return \"\";\r\n                        }\r\n\r\n                        if (dataImported === \"\" || dataImported === null) {\r\n                            return this.delValue(this.escapeHtml(dataDb));\r\n                        }\r\n\r\n                        break;\r\n\r\n                    case \"right\":\r\n                        switch (dataImported) {\r\n                            case null:\r\n                                return this.insValue(nullValue);\r\n                            case false:\r\n                                return this.insValue(falseValue);\r\n                            case true:\r\n                                return this.insValue(trueValue);\r\n                            case \"\":\r\n                                return \"\";\r\n                        }\r\n\r\n                        if (dataDb === \"\" || dataDb === null) {\r\n                            return this.insValue(this.escapeHtml(dataImported));\r\n                        }\r\n\r\n                        break;\r\n                }\r\n\r\n                dataDb += \"\";\r\n                dataImported += \"\";\r\n\r\n                if (!this.showDiff) {\r\n                    switch (side) {\r\n                        case \"left\":\r\n                            return this.escapeHtml(dataDb);\r\n                        case \"right\":\r\n                            return this.escapeHtml(dataImported);\r\n                    }\r\n                }\r\n\r\n                // string json\r\n                if (dataDb.match(/^\\s*[{\\[]/) || dataImported.match(/^\\s*[{\\[]/)) {\r\n                    diff = Diff.diffJson(dataDb, dataImported);\r\n                }\r\n                // string multiligne\r\n                else if (dataDb.match(/\\n/)) {\r\n                    diff = Diff.diffTrimmedLines(dataDb, dataImported);\r\n                }\r\n                // string avec des mots\r\n                else if (dataDb.match(/\\s/)) {\r\n                    diff = Diff.diffWords(dataDb, dataImported);\r\n                } else {\r\n                    diff = Diff.diffSentences(dataDb, dataImported);\r\n                }\r\n\r\n                let html = \"\";\r\n                diff.forEach(part => {\r\n                    let value = this.escapeHtml(part.value);\r\n\r\n                    switch (side) {\r\n                        case \"left\":\r\n                            if (part.removed) {\r\n                                html += this.delValue(value);\r\n                            }\r\n                            break;\r\n\r\n                        case \"right\":\r\n                            if (part.added) {\r\n                                html += this.insValue(value);\r\n                            }\r\n                            break;\r\n                    }\r\n\r\n                    if (!part.removed && !part.added) {\r\n                        if (value === \"\") {\r\n                            value = \" \";\r\n                        }\r\n\r\n                        html += value;\r\n                    }\r\n                });\r\n\r\n                return html;\r\n            },\r\n        }\r\n    }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n    %full-size {\r\n        position: absolute;\r\n        margin: 0;\r\n        top: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n    }\r\n\r\n    .mapping-item {\r\n        border-bottom: 1px solid #eee;\r\n    }\r\n    \r\n    #import-tabs {\r\n        position: sticky;\r\n        top: 1rem;\r\n    }\r\n\r\n    .data-diff {\r\n        white-space: pre-wrap;\r\n        //overflow: auto;\r\n        font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n\r\n        ins, del {\r\n            text-decoration: none;\r\n        }\r\n\r\n        ins {\r\n            background: rgba(63, 147, 73, 0.25);\r\n        }\r\n\r\n        del {\r\n            background: rgba(255, 133, 111, 0.25);\r\n        }\r\n    }\r\n\r\n    .data-table {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        table-layout: fixed;\r\n        font-size: 0.875rem;\r\n\r\n        td, th {\r\n            padding: 1px 2px;\r\n            border: 1px solid #eee;\r\n        }\r\n\r\n        td {\r\n            overflow: auto;\r\n            word-wrap: break-word;\r\n            word-break: break-all;\r\n            \r\n            input + label {\r\n                opacity: 0.6;\r\n            }\r\n            \r\n            input:checked + label {\r\n                opacity: 1.0;\r\n            }\r\n        }\r\n\r\n        th {\r\n            background: rgba(0, 0, 0, 0.05);\r\n        }\r\n\r\n        .scroll-sync-container {\r\n            max-height: 20em;\r\n            overflow: auto;\r\n            position: relative;\r\n        }\r\n\r\n        .data-db, .data-result, .data-import {\r\n            padding: 0;\r\n            width: 30%;\r\n        }\r\n\r\n        .data-db, .data-import {\r\n            label {\r\n                width: 100%;\r\n            }\r\n        }\r\n        \r\n        .data-title {\r\n            line-height: 1.1;\r\n            \r\n            em {\r\n                float: right;\r\n                font-size: 0.8em;\r\n                font-weight: normal;\r\n                color: #999;\r\n            }\r\n        }\r\n        \r\n        .data-result {\r\n            position: relative;\r\n            overflow: visible;\r\n            \r\n            > .custom-control {\r\n                @extend %full-size;\r\n\r\n                label {\r\n                    @extend %full-size;\r\n                    left: 24px;\r\n                    \r\n                    .input-group-text {\r\n                        padding: 0.25em;\r\n                        cursor: pointer;\r\n                        \r\n                        i {\r\n                            font-size: 10px;\r\n                        }\r\n                    }\r\n                    \r\n                    >.input-group {\r\n                        @extend %full-size;\r\n                        \r\n                        margin: -1px;\r\n                        right: -3px;\r\n                        \r\n                        .scroll-sync-container {\r\n                            flex: 1;\r\n\r\n                            .result-editor {\r\n                                padding: 2px 1px;\r\n                                width: 100%;\r\n                                height: 100%;\r\n                                cursor: text;\r\n                                background: transparent;\r\n                                \r\n                                &:focus {\r\n                                    outline: 0 solid transparent;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .data-different th {\r\n            background: rgb(255, 210, 190)\r\n        }\r\n    }\r\n</style>\r\n",".data-table .data-result > .custom-control label > .input-group, .data-table .data-result > .custom-control label, .data-table .data-result > .custom-control {\n  position: absolute;\n  margin: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.mapping-item {\n  border-bottom: 1px solid #eee;\n}\n\n#import-tabs {\n  position: sticky;\n  top: 1rem;\n}\n\n.data-diff {\n  white-space: pre-wrap;\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n.data-diff ins, .data-diff del {\n  text-decoration: none;\n}\n.data-diff ins {\n  background: rgba(63, 147, 73, 0.25);\n}\n.data-diff del {\n  background: rgba(255, 133, 111, 0.25);\n}\n\n.data-table {\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n  font-size: 0.875rem;\n}\n.data-table td, .data-table th {\n  padding: 1px 2px;\n  border: 1px solid #eee;\n}\n.data-table td {\n  overflow: auto;\n  word-wrap: break-word;\n  word-break: break-all;\n}\n.data-table td input + label {\n  opacity: 0.6;\n}\n.data-table td input:checked + label {\n  opacity: 1;\n}\n.data-table th {\n  background: rgba(0, 0, 0, 0.05);\n}\n.data-table .scroll-sync-container {\n  max-height: 20em;\n  overflow: auto;\n  position: relative;\n}\n.data-table .data-db, .data-table .data-result, .data-table .data-import {\n  padding: 0;\n  width: 30%;\n}\n.data-table .data-db label, .data-table .data-import label {\n  width: 100%;\n}\n.data-table .data-title {\n  line-height: 1.1;\n}\n.data-table .data-title em {\n  float: right;\n  font-size: 0.8em;\n  font-weight: normal;\n  color: #999;\n}\n.data-table .data-result {\n  position: relative;\n  overflow: visible;\n}\n.data-table .data-result > .custom-control label {\n  left: 24px;\n}\n.data-table .data-result > .custom-control label .input-group-text {\n  padding: 0.25em;\n  cursor: pointer;\n}\n.data-table .data-result > .custom-control label .input-group-text i {\n  font-size: 10px;\n}\n.data-table .data-result > .custom-control label > .input-group {\n  margin: -1px;\n  right: -3px;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container {\n  flex: 1;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container .result-editor {\n  padding: 2px 1px;\n  width: 100%;\n  height: 100%;\n  cursor: text;\n  background: transparent;\n}\n.data-table .data-result > .custom-control label > .input-group .scroll-sync-container .result-editor:focus {\n  outline: 0 solid transparent;\n}\n.data-table .data-different th {\n  background: #ffd2be;\n}\n\n/*# sourceMappingURL=MappingContent.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$1 = {
    components: {
        MappingContent: __vue_component__
    },
    props: {
        data: Object,
        executeRoute: String,
    },
    data: function () {
        var data = this.data;
        return {
            key: data.key,
            choiceTypes: data.choiceTypes,
            import: data.import,
            importResult: null,
            importing: false,
            imported: false,
        };
    },
    mounted: function () {
        this.importing = false;
    },
    methods: {
        getChoiceCounterValue: function (mapping, type) {
            switch (type) {
                case ImportChoiceTypeEnum.Update:
                    return mapping.collection.filter(function (i) {
                        return i.selectedValue !== undefined &&
                            i.selectedValue !== ImportChoiceTypeEnum.Create &&
                            i.selectedValue !== ImportChoiceTypeEnum.Ignore;
                    }).length;
                case ImportChoiceTypeEnum.Create:
                case ImportChoiceTypeEnum.Ignore:
                    return mapping.collection.filter(function (i) { return i.selectedValue === type; }).length;
            }
        },
        isOptionActive: function (mapping, candidate) {
            if (!mapping.dependsOnName) {
                return true;
            }
            var match = this.data.import.mappings.find(function (_) { return _.name === mapping.dependsOnName; });
            if (!match) {
                return true;
            }
            var candidateProp = candidate.propertyDetails.find(function (p) { return p.key === mapping.dependsOnProperty; }).value;
            return match.collection.find(function (item) { return item.selectedValue == candidateProp; }) != null;
        },
        getCandidates: function (mapping) {
            var _this = this;
            return mapping.candidates.filter(function (c) { return _this.isOptionActive(mapping, c); });
        },
        execute: function (event) {
            var _this = this;
            event.preventDefault();
            var form = event.target;
            var fd = new FormData(form);
            this.importing = true;
            window["$"].ajax({
                url: this.executeRoute,
                data: fd,
                processData: false,
                contentType: false,
                type: "post",
                success: function (data) {
                    _this.importResult = data;
                    _this.importing = false;
                    _this.imported = true;
                }
            });
        }
    }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "form",
    {
      attrs: { method: "post", action: _vm.executeRoute },
      on: { submit: _vm.execute }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.key,
            expression: "key"
          }
        ],
        attrs: { type: "hidden", name: "Key" },
        domProps: { value: _vm.key },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.key = $event.target.value;
          }
        }
      }),
      _vm._v(" "),
      _c("h4", [_vm._v(_vm._s(_vm.data.import.title))]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-2" }, [
          _c(
            "ul",
            {
              staticClass: "nav nav-pills flex-column text-right",
              attrs: { id: "import-tabs", role: "tablist" }
            },
            [
              _vm._l(_vm.data.import.mappings, function(mapping, index) {
                return _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      class:
                        "nav-link p-1 px-2 " + (index === 0 ? "active" : ""),
                      attrs: {
                        "data-toggle": "tab",
                        role: "tab",
                        id: "tab-" + mapping.hashCode,
                        href: "#content-" + mapping.hashCode,
                        "aria-controls": "content-" + mapping.hashCode
                      }
                    },
                    [
                      _vm._v(
                        "\n\n                        " +
                          _vm._s(mapping.label) +
                          "\n\n                        "
                      ),
                      _vm._l(_vm.choiceTypes, function(choiceType) {
                        return _c(
                          "span",
                          {
                            key: choiceType.value,
                            class: "counter-" + choiceType.value,
                            attrs: {
                              title: choiceType.label,
                              "data-count": _vm.getChoiceCounterValue(
                                mapping,
                                choiceType.value
                              )
                            }
                          },
                          [_c("i", { class: choiceType.icon })]
                        )
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _c("li", { staticClass: "p-4" }, [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: {
                        disabled:
                          _vm.importing ||
                          (_vm.imported && !_vm.importResult.error)
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-database" }),
                      _vm._v(" Importer\n                        ")
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.importing
                ? _c("li", [
                    _c("i", {
                      staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.importResult
                ? _c(
                    "li",
                    { staticClass: "import-result text-left" },
                    [
                      _vm.importResult.error
                        ? _c("div", { staticClass: "alert alert-danger" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.importResult.error) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.importResult.result, function(result) {
                        return _vm.importResult.result
                          ? [
                              _c("strong", [
                                _vm._v(
                                  " " + _vm._s(result.objectTypeName) + " "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(result.counters, function(
                                  counter,
                                  name
                                ) {
                                  return _c("li", [
                                    _c("i", {
                                      class: _vm.choiceTypes.find(function(c) {
                                        return c.value === name
                                      }).icon
                                    }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(name) +
                                        " : " +
                                        _vm._s(counter) +
                                        "\n                            "
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tab-content col-10" },
          _vm._l(_vm.data.import.mappings, function(mapping, index) {
            return _c("mapping-content", {
              key: index,
              attrs: {
                data: _vm.data,
                index: index,
                mapping: mapping,
                candidates: _vm.getCandidates(mapping)
              }
            })
          }),
          1
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-06db1cd8_0", { source: "[data-count] {\n  font-size: 0.9em;\n  padding: 0 2px;\n  width: 2.5em;\n  text-align: left;\n  display: inline-block;\n  white-space: nowrap;\n}\n[data-count]:after {\n  content: \" \" attr(data-count);\n}\n[data-count=\"0\"] {\n  opacity: 0.2;\n}\n\n/*# sourceMappingURL=ImportMapper.vue.map */", map: {"version":3,"sources":["C:\\Dev\\orezo\\vendor\\helium\\src\\Helium.SettingsImportExport.Mvc\\_wwwsrc\\src\\js\\Components\\ImportMapper.vue","ImportMapper.vue"],"names":[],"mappings":"AAiKA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AChKA;ADmKA;EACA,6BAAA;AChKA;ADmKA;EACA,YAAA;AChKA;;AAEA,2CAA2C","file":"ImportMapper.vue","sourcesContent":["<template>\r\n    <form method=\"post\" :action=\"executeRoute\" @submit=\"execute\">\r\n        <input type=\"hidden\" name=\"Key\" v-model=\"key\" />\r\n        \r\n        <h4>{{data.import.title}}</h4>\r\n        <hr/>\r\n        \r\n        <div class=\"row\">\r\n            <div class=\"col-2\">\r\n                <ul class=\"nav nav-pills flex-column text-right\" id=\"import-tabs\" role=\"tablist\">\r\n                    <li class=\"nav-item\" v-for=\"(mapping, index) of data.import.mappings\">\r\n                        <a :class=\"'nav-link p-1 px-2 ' + (index === 0 ? 'active' : '')\"\r\n                           data-toggle=\"tab\"\r\n                           role=\"tab\"\r\n                           :id=\"'tab-' + mapping.hashCode\"\r\n                           :href=\"'#content-' + mapping.hashCode\"\r\n                           :aria-controls=\"'content-' + mapping.hashCode\">\r\n\r\n                            {{mapping.label}}\r\n\r\n                            <span :class=\"'counter-' + choiceType.value\"\r\n                                  :title=\"choiceType.label\"\r\n                                  :data-count=\"getChoiceCounterValue(mapping, choiceType.value)\"\r\n                                  v-for=\"choiceType in choiceTypes\" :key=\"choiceType.value\">\r\n                            <i :class=\"choiceType.icon\"></i> \r\n                        </span>\r\n                        </a>\r\n                    </li>\r\n\r\n                    <li class=\"p-4\">\r\n                        <div class=\"text-center\">\r\n                            <button class=\"btn btn-sm btn-primary\" :disabled=\"importing || (imported && !importResult.error)\">\r\n                                <i class=\"fa fa-database\"></i> Importer\r\n                            </button>\r\n                        </div>\r\n                    </li>\r\n\r\n                    <li v-if=\"importing\">\r\n                        <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n                    </li>\r\n\r\n                    <li class=\"import-result text-left\" v-if=\"importResult\">\r\n                        <div class=\"alert alert-danger\" v-if=\"importResult.error\">\r\n                            {{importResult.error}}\r\n                        </div>\r\n\r\n                        <template v-if=\"importResult.result\" v-for=\"result in importResult.result\">\r\n                            <strong> {{result.objectTypeName}} </strong>\r\n\r\n                            <ul>\r\n                                <li v-for=\"(counter, name) in result.counters\">\r\n                                    <i :class=\"choiceTypes.find(c => c.value === name).icon\"></i>\r\n                                    {{name}} : {{counter}}\r\n                                </li>\r\n                            </ul>\r\n                        </template>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n    \r\n            <div class=\"tab-content col-10\">\r\n                <mapping-content\r\n                        v-for=\"(mapping, index) of data.import.mappings\"\r\n                        :key=\"index\"\r\n                        :data=\"data\"\r\n                        :index=\"index\"\r\n                        :mapping=\"mapping\"\r\n                        :candidates=\"getCandidates(mapping)\"/>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</template>\r\n\r\n<script lang=\"ts\">\r\n    import {ImportPrepareViewModel} from \"../Models/ImportPrepareViewModel\";\r\n    import {ImportMappingCollection} from \"../Models/ImportMappingCollection\";\r\n    import {ImportChoiceTypeEnum} from \"../Models/ImportableChoiceType\";\r\n    import {ImportContainerBase} from \"../Models/ImportContainerBase\";\r\n    import MappingContent from \"./MappingContent.vue\";\r\n\r\n    export default {\r\n        components: {\r\n            MappingContent\r\n        },\r\n        props: {\r\n            data: Object as () => ImportPrepareViewModel,\r\n            executeRoute: String,\r\n        }, \r\n        data() {\r\n            const data = this.data;\r\n\r\n            return {\r\n                key: data.key,\r\n                choiceTypes: data.choiceTypes,\r\n                import: data.import,\r\n                importResult: null,\r\n                importing: false,\r\n                imported: false,\r\n            } as ImportPrepareViewModel;\r\n        },\r\n        mounted() {\r\n            this.importing = false;\r\n        },\r\n        methods: {\r\n            getChoiceCounterValue(mapping: ImportMappingCollection, type: ImportChoiceTypeEnum) : number {\r\n                switch (type) {\r\n                    case ImportChoiceTypeEnum.Update:\r\n                        return mapping.collection.filter(i => \r\n                            i.selectedValue !== undefined && \r\n                            i.selectedValue !== ImportChoiceTypeEnum.Create &&\r\n                            i.selectedValue !== ImportChoiceTypeEnum.Ignore).length;\r\n                        \r\n                    case ImportChoiceTypeEnum.Create:\r\n                    case ImportChoiceTypeEnum.Ignore:\r\n                        return mapping.collection.filter(i => i.selectedValue === type).length;\r\n                }\r\n            },\r\n            isOptionActive(mapping: ImportMappingCollection, candidate: ImportContainerBase) : boolean {\r\n                if (!mapping.dependsOnName) {\r\n                    return true;\r\n                }\r\n                \r\n                const match = this.data.import.mappings.find(_ => _.name === mapping.dependsOnName) as ImportMappingCollection;\r\n                \r\n                if (!match) {\r\n                    return true;\r\n                }\r\n                \r\n                let candidateProp = candidate.propertyDetails.find(p => p.key === mapping.dependsOnProperty).value;\r\n\r\n                return match.collection.find(item => item.selectedValue == candidateProp) != null;\r\n            },\r\n            getCandidates(mapping: ImportMappingCollection) {\r\n                return mapping.candidates.filter(c => this.isOptionActive(mapping, c));\r\n            },\r\n            execute(event: Event) {\r\n                event.preventDefault();\r\n                \r\n                const form = event.target as HTMLFormElement;\r\n                const fd = new FormData(form);\r\n                \r\n                this.importing = true;\r\n\r\n                window[\"$\"].ajax({\r\n                    url: this.executeRoute,\r\n                    data: fd,\r\n                    processData: false,\r\n                    contentType: false,\r\n                    type: \"post\",\r\n                    success: (data) => {\r\n                        this.importResult = data;\r\n                        this.importing = false;\r\n                        this.imported = true;\r\n                    }\r\n                });\r\n            }\r\n        }\r\n    }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n    [data-count] {\r\n        font-size: 0.9em;\r\n        padding: 0 2px;\r\n        width: 2.5em;\r\n        text-align: left;\r\n        display: inline-block;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    [data-count]:after {\r\n        content: \" \" attr(data-count);\r\n    }\r\n\r\n    [data-count=\"0\"] {\r\n        opacity: 0.2;\r\n    }\r\n</style>\r\n","[data-count] {\n  font-size: 0.9em;\n  padding: 0 2px;\n  width: 2.5em;\n  text-align: left;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n[data-count]:after {\n  content: \" \" attr(data-count);\n}\n\n[data-count=\"0\"] {\n  opacity: 0.2;\n}\n\n/*# sourceMappingURL=ImportMapper.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$2 = {
    components: {
        ImportMapper: __vue_component__$1
    },
    props: {
        uploadRoute: String,
        executeRoute: String,
    },
    data: function () {
        return {
            loading: false,
            error: false,
            importData: null,
        };
    },
    methods: {
        uploadFile: function (event) {
            var _this = this;
            var input = event.target;
            var form = input.form;
            var fd = new FormData(form);
            if (input.value == "") {
                return;
            }
            this.loading = true;
            this.error = "";
            window["$"].ajax({
                url: this.uploadRoute,
                data: fd,
                processData: false,
                contentType: false,
                type: "post",
                success: function (data) {
                    _this.loading = false;
                    if (data.error) {
                        _this.error = data.message;
                        return;
                    }
                    _this.importData = data;
                },
                error: function (xhr, message) {
                    _this.loading = false;
                    _this.error = message;
                }
            });
            input.value = "";
        }
    }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { attrs: { id: "import-parametrage-container" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "form",
          { attrs: { method: "post", enctype: "multipart/form-data" } },
          [
            _c("div", { staticClass: "input-group mb-3" }, [
              _c("div", { staticClass: "custom-file" }, [
                _c("input", {
                  staticClass: "custom-file-input",
                  attrs: {
                    type: "file",
                    id: "importfile",
                    name: "ImportFile",
                    accept: ".json",
                    required: ""
                  },
                  on: { change: _vm.uploadFile }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-file-label",
                    attrs: { for: "importfile" }
                  },
                  [_vm._v("Veuillez choisir un fichier JSON")]
                )
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _vm.loading
            ? _c("i", { staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw" })
            : _vm._e(),
          _vm._v(" "),
          _vm.error
            ? _c("div", { staticClass: "alert alert-warning" }, [
                _c("i", { staticClass: "fa fa-warning fa-3x fa-fw" }),
                _vm._v(" " + _vm._s(_vm.error) + "\n            ")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.error && !_vm.loading && _vm.importData != null
            ? _c("import-mapper", {
                attrs: {
                  data: _vm.importData,
                  "execute-route": _vm.executeRoute
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

(function ($) {
    $(function () {
        var $el = $("#import-uploader");
        if ($el.length === 0) {
            return;
        }
        var el = $el[0];
        var props = {};
        for (var i = 0; i < el.attributes.length; i++) {
            var attr = el.attributes.item(i);
            props[attr.name] = attr.value;
        }
        new Vue({
            el: $el[0],
            render: function (h) { return h(__vue_component__$2, {
                props: props
            }); }
        });
    });
})(window["$"]);
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// C:/JenkinsWorkspace/Orezo/Orezo.Production/source/vendor/helium/src/Helium.SettingsImportExport.Mvc/_wwwsrc/dist/index.js
// module id = 683
// module chunks = 0